'use client';
import { lazy, type ReactNode } from 'react';

// next/dynamic's server preload omits the CSP nonce in Next 15. Keep lazy
// loading through the trusted webpack runtime without emitting that preload.
const EnabledVoiceProvider = lazy(() =>
  import('./VoiceProvider').then(module => ({ default: module.VoiceProvider }))
);

export function VoiceBoundary({ children }: { children: ReactNode }) {
  if (process.env.NEXT_PUBLIC_ATTUNE_VOICE_ENABLED !== 'true') return children;
  return <EnabledVoiceProvider>{children}</EnabledVoiceProvider>;
}
